import React, { useMemo } from 'react';
import { Tooltip } from 'antd';
import ticketAvailableIcon from '../../assets/Ticket1.png';
import ticketUnavailableIcon from '../../assets/Ticket2.png';

const STATUS_CONFIG = {
  eligible: {
    icon: ticketAvailableIcon,
    tooltip: 'This CTA is eligible for ticket creation',
  },
  ineligible: {
    icon: ticketUnavailableIcon,
    tooltip: (
      <div>
        <div>This CTA type does not support ticket creation.</div>
        <div>Currently, only URL and Phone CTAs are supported.</div>
      </div>
    ),
  },
  ticketed: {
    icon: ticketUnavailableIcon,
    tooltip: (
      <div>
        <div>This CTA already has a ticket and cannot be created again.</div>
      </div>
    ),
  },
};

const ELIGIBLE_TYPES = ['URL', 'Phone'];

const CtaTicketStatusTag = ({ record }) => {
  const status = useMemo(() => {
    if (record.workOrderId) {
      return 'ticketed';
    }
    if (ELIGIBLE_TYPES.includes(record.ctaType)) {
      return 'eligible';
    }
    return 'ineligible';
  }, [record.workOrderId, record.ctaType]);

  const config = STATUS_CONFIG[status];

  return (
    <Tooltip title={config.tooltip}>
      <span style={{ cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}>
        <img
          src={config.icon}
          alt={status}
          style={{ width: 20, height: 20, objectFit: 'contain' }}
        />
      </span>
    </Tooltip>
  );
};

export default CtaTicketStatusTag;
